import { Modal, Button } from "react-bootstrap";

const UnsavedChangesModal = ({ show, onDiscard, onCancel }) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Body>
        Imate neshranjene spremembe. Ali ste prepričani, da želite zapustiti
        urejanje splošnih podatkov?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel}>
          Nazaj na urejanje
        </Button>
        <Button variant="danger" onClick={onDiscard}>
          Zapusti urejanje
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnsavedChangesModal;
